import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Loader from './widgets/Loader';
import Layout from './widgets/Layout'; 

const Login           = lazy(() => import('./screens/Login'));
const Navigation      = lazy(() => import('./screens/Navigation'));

const EventList       = lazy(() => import('./screens/event/List'));
const EventCreator    = lazy(() => import('./screens/event/Creator'));
const EventDetail     = lazy(() => import('./screens/event/Detail'));
const EventOrder      = lazy(() => import('./screens/event/Order'));

const ReportList      = lazy(() => import('./screens/report/List'));
const ReportCreator   = lazy(() => import('./screens/report/Creator'));

const SmsCreator      = lazy(() => import('./screens/sms/Creator'));

export function App() {
  const token = localStorage.getItem('token');
  if ( !token ) {
    return (
      <Router>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route exact path='/' element={<Login />}>
            </Route>
          </Routes>
        </Suspense>
      </Router>
    )
  }
  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route exact path='/' element={<Layout />}>
            <Route exact path='/' element={<Navigation />} />
            
            <Route exact path='/navigation' element={<Navigation />} />
            
            
            <Route exact path='/events' element={<EventList />} />
            <Route exact path='/event/creator' element={<EventCreator />} />
            <Route exact path='/event/:id' element={<EventDetail />} />
            <Route exact path='/event/order/:id' element={<EventOrder />} />
            
            <Route exact path='/reports' element={<ReportList />} />
            <Route exact path='/report/creator' element={<ReportCreator />} />
            
            <Route exact path='/sms' element={<SmsCreator />} />
          </Route>
          
        </Routes>
      </Suspense>
    </Router>
  )
}
